import { axiosInstance } from "@/lib/axiosInstance";
import config from "@/lib/config";
import axios from "axios";

export const deleteCategory = async (id: string) => {
  try {
    const response = await axiosInstance.delete(
      `${config.apiUrl}/categories/${id}`
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw new Error(
        error.response?.data?.message || "Error deleting category"
      );
    } else {
      throw new Error("An unknown error occurred");
    }
  }
};
